// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_Dky","cls2":"common-cls2_1dh common-cls1_Dky"};